























import Vue from "vue";
export default Vue.extend({
  name: "NotificationBtn",

  props: {
    count: { type: Number, default: 0 },
  },
});
